import createPocketBaseNewsLoader from './pocketbase';

const newsZH = {
  title: '企业动态',
  tabs: ['新闻发布', '活动', '解决方法', '其他'],
  list: [],
  share: '分享',
  doneContent: {
    title: '本次研讨会受理已结束。',
    beforeLink: '如果您想了解今后举行的研讨会信息，请使用',
    link: '此表格',
    afterLink: '进行申请。',
    href: 'contact-us',
  },
  wxScan: '微信扫一扫',
  more: '查看更多',
  back: '企业动态',
  excludeList: ['20210827', '20211216'],
};

const loadNewsZH = createPocketBaseNewsLoader({
  collection: 'news',
  lang: 'zh',
});

export default newsZH;
export { loadNewsZH };
